import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  EXTERNAL_FOOD_IMAGE_FALLBACK,
  resolveExternalFoodImageUrl,
} from "../../../../utils/external-food-image";

function ExternalFoodImage({
  image,
  imageType,
  className,
  alt = "",
  loading,
}) {
  const resolved = resolveExternalFoodImageUrl(image, imageType);
  const [src, setSrc] = useState(
    () => resolved || EXTERNAL_FOOD_IMAGE_FALLBACK,
  );
  const [failed, setFailed] = useState(() => !resolved);

  useEffect(() => {
    const next = resolveExternalFoodImageUrl(image, imageType);
    setFailed(!next);
    setSrc(next || EXTERNAL_FOOD_IMAGE_FALLBACK);
  }, [image, imageType]);

  const handleError = () => {
    if (failed) return;
    setFailed(true);
    setSrc(EXTERNAL_FOOD_IMAGE_FALLBACK);
  };

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      loading={loading}
      onError={handleError}
    />
  );
}

ExternalFoodImage.propTypes = {
  image: PropTypes.string,
  imageType: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
  loading: PropTypes.string,
};

export default ExternalFoodImage;
